import { render, staticRenderFns } from "./EmailQueue.vue?vue&type=template&id=94da7536&"
import script from "./EmailQueue.vue?vue&type=script&lang=js&"
export * from "./EmailQueue.vue?vue&type=script&lang=js&"
import style0 from "./EmailQueue.vue?vue&type=style&index=0&id=94da7536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports